import { LeadReport1 } from "./_components/lead-report-1";

const EmployeeLeadsReportPage = () => {
  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Lead Reports</h3>
      </div>

      <div className="mt-4">
        <LeadReport1 />
      </div>
    </div>
  );
};

export default EmployeeLeadsReportPage;
